<template>
    <div class="modal fade" data-backdrop="static" data-keyboard="false">
       <div :class="lg? 'modal-dialog modal-lg': md? 'modal-dialog modal-md': 'modal-dialog'">
            <div class="modal-content">                
                <div class="modal-header">
                    <h4 class="modal-title">{{title}}</h4>
                    <button type="button" @click="modalClose" class="close" data-dismiss="modal">&times;</button>
                </div>      
                <div class="modal-body">
                    <slot></slot> 
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" @click="modalClose" data-dismiss="modal">
                        <i class="fa fa-ban"></i>
                        {{cancelText?cancelText:'Cancelar'}}
                    </button>
                    <slot name="btnFooter"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['title', 'cancelText','lg', 'md'],
        methods: {
            modalClose() {                
                this.$emit('modalClose');
            }
        }
    }
</script>